import styled from "styled-components";

export const QuestionText = styled.p`
    font-size: 18px;
    margin-bottom: 0px;
    color: #fff;
`;

export const QuestionOrder = styled.p`
    font-size: 60px;
    color: var(--color-petrol-40);
    line-height: 70px;
    margin-bottom: 0px;
    font-weight: 600;
`;